import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  UncontrolledTooltip,
  Progress,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import "../../../assets/css/test.css";

import { Link } from "react-router-dom";
import AttendanceModel from "../../../models/Attendance.modal";
import classModal from "models/class.modal";
import Loader from "components/loader/Loader";
const Attendance = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };
  const [status, setStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [AllClass, setAllClass] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListDataAllAttden = async (currentStatus) => {
    setIsLoading(true);

    const apiCall = currentStatus
      ? classModal.listClassNewfilter(parameters) // Call regular API when checked
      : classModal.listClassNew(parameters); // Call filter API when unchecked

    try {
      const result = await apiCall;
      setIsLoading(false);
      if (result) {
        setDataList(result);
        setCurrentPage(result?.meta?.current_page);
        setPerPage(result?.meta?.per_page);
      }
    } catch (error) {
      setIsLoading(false);
     
    }
  };

  console.log("checkbox check", status);
  useEffect(() => {
    getListDataAllAttden(status);
  }, [location]);

  const handleCheckboxChange = async (e) => {
    const newStatus = e.target.checked;
    setStatus(newStatus); // Update the checkbox status
    await getListDataAllAttden(newStatus); // Pass the updated status to fetch data
  };

  return (
    <>
      <div className="pt-7 px-4 overflow-x-hidden">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Attendance List</h3>
                <div className="d-flex">
                  <span className="mr-2">Due Class</span>
                  <div>
                    <input
                      type="checkbox"
                      checked={status}
                      onChange={handleCheckboxChange}
                    />
                  </div>
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">SN.</th>
                    <th scope="col">Class</th>
                    <th scope="col">Tutor Name</th>
                    <th scope="col">Subject</th>
                    <th scope="col">Student</th>
                    {/* <th scope="col">Last Class Marked</th> */}
                    <th scope="col">Remaining Class</th>
                    <th scope="col">Duration Left</th>
                    <th scope="col">Class Status</th>
                    <th scope="col">Cycle Payment Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {isLoading ? (
                    <tr>
                      <td className="text-center align-middle py-4" colSpan={10}>Please Wait...
                      <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {dataList?.data?.map((item, index) => {
                        const totalDuration =
                          item?.adminApi_classcycle?.total_duration +
                          item?.adminApi_classcycle?.student_recovery;
                        const remainingDuration =
                          item?.adminApi_classcycle?.remaining_duration +
                          item?.adminApi_classcycle?.remaining_student_recovery;

                        const progressPercentage = totalDuration
                          ? (remainingDuration / totalDuration) * 100
                          : 0;
                        let remainingTime = remainingDuration;
                        let remaingTimeType = "Minutes";
                        if (remainingDuration > 60) {
                          remaingTimeType = "Hours";
                          remainingTime = Math.floor(remainingDuration / 60);
                        }
                       console.log("ttttto",item)
                        return (
                          <tr className="h-30vh" key={`listrow${index}`}>
                            <td style={{ padding: "0.3rem" }}>{index + 1}</td>
                            <td style={{ padding: "0.3rem" }}>
                              <Link
                                to={`/admin/attendance/attendance-profile/${item?.id}/${item.parent_id}/${item?.adminApi_classcycle?.class_id_id }`}
                              >
                                {item.name}
                              </Link>
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              {item?.tutorApi_tutor?.auth_user?.first_name}
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              {item?.subjectNames?.join(", ")}
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              {item?.student_data?.map(
                                (student, studentIndex) => (
                                  <span key={`student${studentIndex}`}>
                                    {studentIndex > 0 && ", "}
                                    {student?.name}
                                  </span>
                                )
                              )}
                            </td>
                            <td className="" style={{ padding: "0.3rem" }}>
                              <Progress
                                className="my-2"
                                value={progressPercentage}
                                style={{ height: "20px" }}
                              >
                                {Math.round(progressPercentage)}%
                              </Progress>
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              {remainingTime} {remaingTimeType}
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              <span
                                style={{
                                  backgroundColor: "green",
                                  color: "white",
                                  padding: "4px 6px",
                                  borderRadius: "50px",
                                }}
                              >
                                {item.status}
                              </span>
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              <span
                                style={{
                                  backgroundColor: "orange",
                                  color: "white",
                                  padding: "4px 6px",
                                  borderRadius: "50px",
                                }}
                              >
                                {item?.adminApi_classcycle
                                  ?.parent_fees_status }
                              </span>
                            </td>
                            <td
                              className="p-0 pt-1"
                              style={{
                                padding: "0.3rem",
                                display: "flex",
                                flexDirection: "row",

                                alignItems: "center",
                              }}
                            >
                              <UncontrolledTooltip
                                placement="bottom"
                                target={`eyeTooltip${index}`}
                              >
                                View
                              </UncontrolledTooltip>
                              <Link
                                style={{
                                  margin: "0 5px",
                                  fontSize: "15px",
                                  color: "blue",
                                  marginTop: "10px",
                                  display: "inline-block",
                                  borderRadius: "30%",
                                }}
                                id={`eyeTooltip${index}`}
                                to={`/admin/attendance/attendance-profile/${item?.id}/${item.parent_id}/${item?.adminApi_classcycle?.class_id_id }/0`}
                              >
                                <i className="fa-solid fa-eye"></i>
                              </Link>
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  )}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
              </CardFooter>
            </Card>
          </div>
        </Row>

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </div>
    </>
  );
};

export default Attendance;
